import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  constructor(private http: HttpClient) {}

  public newGetProductsByCategorySlug(parentSlug: string, start: any, pice: any) {
    return this.http.get(environment.productRest + '?categories.slug=' + parentSlug + '&_start=' + start + '&_limit=' + pice + '&_sort=name:ASC')
          .pipe(
            catchError(this.handleError)
          );
  }

  public newGetCategorysByParentSlug(parentSlug: string) {
    return this.http.get(environment.categoryRest + '?parents.slug_eq=' + parentSlug + '&_limit=-1')
          .pipe(
            catchError(this.handleError)
          );
  }

  public newGetProductById(id: string) {
    return this.http.get(environment.productRest + '/' + id)
          .pipe(
            catchError(this.handleError)
          );
  }

  public getCategoryCount( parentSlug: string ) {
    return this.http.get(environment.categoryRest + '/count' + '?parents.slug_eq=' + parentSlug)
      .pipe(
        catchError(this.handleError),
      );
  }

  public getProductCount(categorySlug: string) {
    return this.http.get<number>(environment.productRest + '/count' + '?categories.slug=' + categorySlug)
      .pipe(
        catchError(this.handleError),
      );
  }

  public findProduct(text){
    return this.http.get<any>(environment.productRest + '?name_contains=' + text + '&_limit=100');
  }

  private handleError(err) {
    // TODO Külön hiba képernyőt létrehozni.
    return throwError('An error happend during loading the configurations' + err);
  }

}
